import { PostNote } from '@/type';
import api from '../../API';

export default {
  findAll(postId: number): Promise<PostNote[]> {
    return api
      .get(`posts/${postId}/notes`)
      .then(response => response.data);
  },
};
